<template>
<div class="BasketCounter">
  <div class="price">
    <div class="d-flex align-center gap-3 justify-end">
      <v-btn
        :icon="true"
        :depressed="true"
        :disabled="!service.is_visible"
        @click="changeAmount(service.id,service.quantity - 1)"
      >
            <span class="cursor-pointer d-flex">
              <svg width="24" height="4" viewBox="0 0 24 4" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <rect width="24" height="3.5" fill="#25325F"/>
              </svg>
            </span>
      </v-btn>
      <v-text-field
        outlined
        dense
        class=" count-input"
        hide-details
        :readonly="true"
        :value="service.quantity"
      />
      <v-btn
        :icon="true"
        :depressed="true"
        :disabled="!service.is_visible"
        @click="changeAmount(service.id,service.quantity + 1)"
      >
            <span class="cursor-pointer d-flex">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.2857 13.7143H0V10.2857H10.2857V0H13.7143V10.2857H24V13.7143H13.7143V24H10.2857V13.7143Z" fill="#25325F"/>
            </svg>
          </span>
      </v-btn>
    </div>

  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

/**
 * Компонент: BasketCounter
 * Описание:
 */
export default {
  name: 'BasketCounter',

  components: {},

  props: {
    id: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      itemInBasket: 'basket/basket/itemInBasket'
    }),
    service() {
      return this.itemInBasket(this.id);
    }
  },

  watch: {},

  created() {
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {
    ...mapActions({
      fetchUserBasket: 'basket/basket/fetchUserBasket',
      changeCount: 'basket/basket/changeCount',
    }),
    async changeAmount(id, count) {
      const data = {
        id,
        quantity: count,
      };
      await this.changeCount(data);
      await this.fetchUserBasket();
    }
  },
};
</script>

<style scoped lang="scss">
.BasketCounter {
  & .price{
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
    gap: 12px;
    padding: 2px 0;
    & .count-input{
      max-width: 100px;
      max-height: 40px;
      text-align: center;
      & ::v-deep input{
        text-align: center;
      }
    }
    & .price-per-item{
      font-weight: 600;
      font-size: 16px;
    }
    & .action{
      .v-btn{
        padding: 12px;
        border: 1px solid var(--color-grey-500);
        border-radius: 50%;
        height: 40px;
        width: 40px;
        & .v-icon{
          font-size: 21px;
        }
      }
    }
  }
  /* Стили компонента */
}
</style>
